// СГЕНЕРИРОВАНО генератором миссий (developer_artifacts/scripts/missionGen).
// Правится не руками, а перегенерацией: npx tsx developer_artifacts/scripts/missionGen/generate_humans_7.cjs
/* eslint-disable */
const mission = {
  "id": "humans_7",
  "campaignFactionId": "humans",
  "order": 7,
  "title": "Мост через Нар",
  "shortTitle": "Миссия VII",
  "description": "Возьми единственную переправу ущелья — и заплати за неё самой дорогой ценой",
  "finalRound": 11,
  "reward": {
    "type": "chest",
    "chestId": "chest_random_epic"
  },
  "rewardIfFactionOwned": null,
  "playerColor": "blue",
  "players": [
    {
      "name": "Луций",
      "color": "blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": false,
      "bonus": "none"
    },
    {
      "name": "Когорты Суллы",
      "color": "violet",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": true,
      "bonus": "none"
    },
    {
      "name": "Заслон Барбы",
      "color": "sky_blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": true,
      "bonus": "none"
    },
    {
      "name": "Стая Ргарха",
      "color": "pink",
      "factionId": "beastmen",
      "selectedSkin": "beastmen_default",
      "isBot": true,
      "bonus": "none"
    }
  ],
  "field": {
    "hexes": {
      "-20,1": "sea",
      "-20,2": "mountain",
      "-19,1": "sea",
      "-19,2": "mountain",
      "-18,1": "sea",
      "-18,2": "mountain",
      "-17,1": "sea",
      "-17,2": "mountain",
      "-16,1": "sea",
      "-16,2": "mountain",
      "-15,1": "sea",
      "-15,2": "mountain",
      "-14,1": "sea",
      "-14,2": "mountain",
      "-13,1": "sea",
      "-13,2": "mountain",
      "-12,1": "sea",
      "-12,2": "mountain",
      "-11,1": "sea",
      "-11,2": "mountain",
      "-10,1": "sea",
      "-10,2": "mountain",
      "-9,1": "sea",
      "-9,2": "mountain",
      "-8,1": "sea",
      "-8,2": "mountain",
      "-7,1": "sea",
      "-7,2": "mountain",
      "-6,1": "sea",
      "-6,2": "mountain",
      "-4,1": "sea",
      "-4,2": "mountain",
      "-3,1": "sea",
      "-3,2": "mountain",
      "-2,1": "sea",
      "-2,2": "mountain",
      "-1,1": "sea",
      "-1,2": "mountain",
      "1,1": "sea",
      "1,2": "mountain",
      "2,1": "sea",
      "2,2": "mountain",
      "3,1": "sea",
      "3,2": "mountain",
      "4,1": "sea",
      "4,2": "mountain",
      "5,1": "sea",
      "5,2": "mountain",
      "6,1": "sea",
      "6,2": "mountain",
      "7,1": "sea",
      "7,2": "mountain",
      "8,1": "sea",
      "8,2": "mountain",
      "9,1": "sea",
      "9,2": "mountain",
      "10,1": "sea",
      "10,2": "mountain",
      "11,1": "sea",
      "11,2": "mountain",
      "12,1": "sea",
      "12,2": "mountain",
      "13,1": "sea",
      "13,2": "mountain",
      "14,1": "sea",
      "14,2": "mountain",
      "15,1": "sea",
      "15,2": "mountain",
      "16,1": "sea",
      "16,2": "mountain",
      "17,1": "sea",
      "17,2": "mountain",
      "18,1": "sea",
      "18,2": "mountain",
      "19,1": "sea",
      "0,1": "road",
      "0,2": "road",
      "-2,-5": "flag_blue",
      "-3,-4": "quarter",
      "-1,-6": "quarter",
      "-1,-5": "quarter",
      "-2,-4": "farm",
      "-3,-5": "farm",
      "-1,-4": "farm",
      "0,-5": "farm",
      "-4,-4": "farm",
      "0,-6": "farm",
      "-4,-3": "farm",
      "-2,-6": "barracks",
      "-2,-3": "road",
      "-1,-3": "road",
      "-1,-2": "road",
      "0,-2": "road",
      "0,-1": "road",
      "0,0": "road",
      "1,0": "central_quarter_violet",
      "1,-1": "farm",
      "-4,-2": "road",
      "-5,-1": "ruins",
      "-5,0": "ruins",
      "-5,1": "road",
      "-5,2": "ruins",
      "-4,-1": "mountain",
      "-4,0": "mountain",
      "-3,-2": "mountain",
      "-3,-1": "mountain",
      "-3,0": "mountain",
      "-2,-2": "mountain",
      "-2,-1": "mountain",
      "2,-1": "mountain",
      "2,0": "mountain",
      "3,-2": "mountain",
      "3,-1": "mountain",
      "3,0": "mountain",
      "4,-2": "mountain",
      "4,-1": "mountain",
      "-6,-1": "mountain",
      "-6,0": "mountain",
      "5,-5": "road",
      "4,-5": "road",
      "3,-4": "road",
      "2,-4": "road",
      "1,-3": "road",
      "0,-3": "road",
      "6,-7": "road",
      "5,-7": "road",
      "4,-6": "road",
      "3,-6": "road",
      "2,-5": "road",
      "1,-5": "road",
      "7,-6": "flag_pink",
      "6,-5": "quarter",
      "8,-7": "quarter",
      "7,-7": "farm",
      "6,-6": "farm",
      "8,-6": "farm",
      "0,3": "flag_sky_blue",
      "-1,4": "quarter",
      "-1,3": "farm",
      "-2,4": "farm",
      "0,4": "road",
      "1,5": "flag_violet",
      "0,5": "quarter",
      "1,6": "quarter",
      "2,5": "quarter",
      "1,4": "farm",
      "0,6": "farm",
      "2,4": "farm",
      "1,7": "farm",
      "2,6": "barracks",
      "-5,3": "road",
      "-5,4": "road",
      "-4,4": "road",
      "-4,5": "road",
      "-3,5": "road",
      "-3,6": "road",
      "-2,6": "road",
      "-1,6": "road",
      "-1,5": "road",
      "4,3": "mountain",
      "4,4": "mountain",
      "4,5": "mountain",
      "-14,0": "mountain",
      "-14,4": "mountain",
      "-14,6": "mountain",
      "-14,8": "mountain",
      "-14,10": "mountain",
      "-14,12": "mountain",
      "-14,14": "mountain",
      "-13,14": "mountain",
      "-12,14": "mountain",
      "-11,14": "mountain",
      "-10,14": "mountain",
      "-9,14": "mountain",
      "-8,14": "mountain",
      "-7,14": "mountain",
      "-6,14": "mountain",
      "-5,14": "mountain",
      "-4,14": "mountain",
      "-3,14": "mountain",
      "-2,14": "mountain",
      "-1,14": "mountain",
      "0,14": "mountain",
      "1,13": "mountain",
      "2,12": "mountain",
      "3,11": "mountain",
      "4,10": "mountain",
      "5,9": "mountain",
      "6,8": "mountain",
      "7,7": "mountain",
      "8,6": "mountain",
      "9,5": "mountain",
      "10,4": "mountain",
      "11,3": "mountain",
      "14,-13": "mountain",
      "14,-11": "mountain",
      "14,-9": "mountain",
      "14,-7": "mountain",
      "14,-5": "mountain",
      "14,-3": "mountain",
      "14,-1": "mountain",
      "-16,0": "mountain",
      "-16,3": "mountain",
      "-16,4": "mountain",
      "-16,5": "mountain",
      "-16,6": "mountain",
      "-16,7": "mountain",
      "-16,8": "mountain",
      "-16,9": "mountain",
      "-16,10": "mountain",
      "-16,11": "mountain",
      "-16,12": "mountain",
      "-16,13": "mountain",
      "-16,14": "mountain",
      "-16,15": "mountain",
      "-16,16": "mountain",
      "-15,-1": "mountain",
      "-15,16": "mountain",
      "-14,-2": "mountain",
      "-14,16": "mountain",
      "-13,-3": "mountain",
      "-13,16": "mountain",
      "-12,-4": "mountain",
      "-12,16": "mountain",
      "-11,-5": "mountain",
      "-11,16": "mountain",
      "-10,-6": "mountain",
      "-10,16": "mountain",
      "-9,-7": "mountain",
      "-9,16": "mountain",
      "-8,-8": "mountain",
      "-8,16": "mountain",
      "-7,-9": "mountain",
      "-7,16": "mountain",
      "-6,-10": "mountain",
      "-6,16": "mountain",
      "-5,-11": "mountain",
      "-5,16": "mountain",
      "-4,-12": "mountain",
      "-4,16": "mountain",
      "-3,-13": "mountain",
      "-3,16": "mountain",
      "-2,-14": "mountain",
      "-2,16": "mountain",
      "-1,-15": "mountain",
      "-1,16": "mountain",
      "0,-16": "mountain",
      "0,16": "mountain",
      "1,-16": "mountain",
      "1,15": "mountain",
      "2,-16": "mountain",
      "2,14": "mountain",
      "3,-16": "mountain",
      "3,13": "mountain",
      "4,-16": "mountain",
      "4,12": "mountain",
      "5,-16": "mountain",
      "5,11": "mountain",
      "6,-16": "mountain",
      "6,10": "mountain",
      "7,-16": "mountain",
      "7,9": "mountain",
      "8,-16": "mountain",
      "8,8": "mountain",
      "9,-16": "mountain",
      "9,7": "mountain",
      "10,-16": "mountain",
      "10,6": "mountain",
      "11,-16": "mountain",
      "11,5": "mountain",
      "12,-16": "mountain",
      "12,4": "mountain",
      "13,-16": "mountain",
      "13,3": "mountain",
      "14,-16": "mountain",
      "15,-16": "mountain",
      "16,-16": "mountain",
      "16,-15": "mountain",
      "16,-14": "mountain",
      "16,-13": "mountain",
      "16,-12": "mountain",
      "16,-11": "mountain",
      "16,-10": "mountain",
      "16,-9": "mountain",
      "16,-8": "mountain",
      "16,-7": "mountain",
      "16,-6": "mountain",
      "16,-5": "mountain",
      "16,-4": "mountain",
      "16,-3": "mountain",
      "16,-2": "mountain",
      "16,-1": "mountain",
      "16,0": "mountain"
    },
    "units": [
      {
        "id": "u_blue_0_-1_-5",
        "hexKey": "-1,-5",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_blue_1_-3_-4",
        "hexKey": "-3,-4",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_2_-2_-4",
        "hexKey": "-2,-4",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_3_-1_-6",
        "hexKey": "-1,-6",
        "ownerId": "player_id_blue",
        "type": "unit_d8",
        "size": 6,
        "maxSize": 8
      },
      {
        "id": "u_blue_4_-3_-5",
        "hexKey": "-3,-5",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 6,
        "maxSize": 10
      },
      {
        "id": "u_blue_5_-2_-3",
        "hexKey": "-2,-3",
        "ownerId": "player_id_blue",
        "type": "unit_d4",
        "size": 4,
        "maxSize": 4
      },
      {
        "id": "u_blue_6_-1_-4",
        "hexKey": "-1,-4",
        "ownerId": "player_id_blue",
        "type": "unit_d4",
        "size": 4,
        "maxSize": 4
      },
      {
        "id": "u_violet_7_1_-1",
        "hexKey": "1,-1",
        "ownerId": "player_id_violet",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_pink_8_5_-5",
        "hexKey": "5,-5",
        "ownerId": "player_id_pink",
        "type": "unit_d10",
        "size": 10,
        "maxSize": 10
      },
      {
        "id": "u_pink_9_6_-7",
        "hexKey": "6,-7",
        "ownerId": "player_id_pink",
        "type": "unit_d10",
        "size": 10,
        "maxSize": 10
      },
      {
        "id": "u_pink_10_5_-6",
        "hexKey": "5,-6",
        "ownerId": "player_id_pink",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "barba_century",
        "hexKey": "0,2",
        "ownerId": "player_id_sky_blue",
        "type": "unit_d8",
        "size": 8,
        "maxSize": 8
      },
      {
        "id": "u_violet_12_1_4",
        "hexKey": "1,4",
        "ownerId": "player_id_violet",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_violet_13_0_6",
        "hexKey": "0,6",
        "ownerId": "player_id_violet",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_violet_14_2_4",
        "hexKey": "2,4",
        "ownerId": "player_id_violet",
        "type": "unit_d8",
        "size": 5,
        "maxSize": 8
      },
      {
        "id": "u_violet_15_2_3",
        "hexKey": "2,3",
        "ownerId": "player_id_violet",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      }
    ],
    "specialBuildings": {
      "1,0": "arsenal",
      "1,5": "fortress"
    },
    "gridConfig": {
      "radius": 20,
      "hexSize": 60,
      "orientation": "flat"
    }
  },
  "policyMarket": [
    {
      "id": "fortificationism",
      "name": "Фортификационизм",
      "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
      "implemented": true,
      "color": "#865333"
    },
    {
      "id": "agrarianism",
      "name": "Аграризм",
      "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
      "implemented": true,
      "color": "#D68A5A"
    },
    {
      "id": "theocracy",
      "name": "Теократия",
      "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
      "implemented": true,
      "color": "#A9A9A9"
    },
    {
      "id": "barbarism",
      "name": "Варварство",
      "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
      "implemented": true,
      "color": "#98172d"
    },
    {
      "id": "patriotism",
      "name": "Патриотизм",
      "description": "Скидка на найм размера отрядов и Арсенал",
      "implemented": true,
      "color": "#98172d"
    },
    {
      "id": "militarism",
      "name": "Милитаризм",
      "description": "Увеличенный урон в ближнем бою",
      "implemented": true,
      "color": "#98172d"
    }
  ],
  "script": [
    {
      "id": "e_0_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h7_take_narnia",
        "type": "capture_city",
        "params": {
          "centralHexKey": "1,5"
        },
        "text": "Возьми Нарнию",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_1_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h7_night_over_narnia",
        "type": "survive_rounds",
        "params": {
          "rounds": 11
        },
        "text": "Ночь над Нарнией",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_2_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h7_hold_bridge",
        "type": "survive_rounds",
        "params": {
          "rounds": 3
        },
        "text": "Продержись 3 раунда: стая бьёт по флангам",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_3_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h7_burn_arsenal",
        "type": "destroy_building",
        "params": {
          "hexKey": "1,0"
        },
        "text": "Сожги склад-арсенал Дома Весов у моста (4 попадания катапульт: сперва арсенал, потом форт под ним)",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_4_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h7_army_lost",
        "type": "lose_all_units",
        "params": {},
        "text": "Армия не должна погибнуть",
        "isMain": false,
        "isFailure": true
      }
    },
    {
      "id": "entry_5_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_violet",
          "hexKey": "1,5"
        }
      }
    },
    {
      "id": "entry_6_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_violet",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_7_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_sky_blue",
          "hexKey": "0,3"
        }
      }
    },
    {
      "id": "entry_8_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_9_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_pink",
          "hexKey": "7,-6"
        }
      }
    },
    {
      "id": "entry_10_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_pink",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_11_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 0,
          "currentPlayerId": "player_id_pink",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_12_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Каша стынет, легат… Я тебе не рассказывал. У меня был сын. Не «был бы» — был. Лихорадка, Остия, шесть лет ему. Я узнал через два месяца — мы стояли в Испании… Жена с тех пор молчала. Так молча и умерла.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_barba_tender.png"
      }
    },
    {
      "id": "e_13_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Квинт… почему сейчас?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_quiet.png"
      }
    },
    {
      "id": "e_14_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Потому что завтра ущелье, а я старый и знаю, как оно бывает… И потому, что в Норике я требовал у тебя чужих детёнышей — за своего. Ты не дал. Спасибо, что не дал, мальчик. Мой Марк — тот, который твой отец, — тоже бы не дал. А я бы дал. Вот и вся разница между нами, и слава богам, что командуешь ты.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_barba_tender.png"
      }
    },
    {
      "id": "e_15_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Каша действительно стынет, Квинт.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_quiet.png"
      }
    },
    {
      "id": "e_16_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Во-от. Учишься главному, легат: когда нечего сказать — ешь.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_barba_grin.png"
      }
    },
    {
      "id": "entry_17_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_18_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_19_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_15_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_20_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_21_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_22_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_23_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,3",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_24_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_25_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_26_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-6",
          "unitId": "u_pink_9_6_-7",
          "unitHexKey": "6,-7",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_27_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-6",
          "unitId": "u_pink_8_5_-5",
          "unitHexKey": "5,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_28_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,-7",
          "unitId": "u_pink_10_5_-6",
          "unitHexKey": "5,-6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_29_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_30_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true,
            "color": "#b09292"
          },
          "round": 1,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_31_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_32_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_33_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_34_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 1,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_35_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_36_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_37_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_38_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_39_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_40_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_41_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_42_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_43_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_44_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_45_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "unitType": "unit_d10",
          "newHexKey": "3,-4"
        }
      }
    },
    {
      "id": "entry_46_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "fromHexKey": "5,-5",
          "toHexKey": "3,-4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_47_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "unitType": "unit_d10",
          "newHexKey": "4,-6"
        }
      }
    },
    {
      "id": "entry_48_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "fromHexKey": "6,-7",
          "toHexKey": "4,-6",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_49_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_50_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_51_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 1,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_52_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 1,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_53_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_54_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_55_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_15_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_56_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_57_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_58_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_59_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,3",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_60_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_61_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_62_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-6",
          "unitId": "u_pink_9_6_-7",
          "unitHexKey": "4,-6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_63_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-6",
          "unitId": "u_pink_8_5_-5",
          "unitHexKey": "3,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_64_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,-7",
          "unitId": "u_pink_10_5_-6",
          "unitHexKey": "5,-6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_65_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_66_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 2,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_67_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_68_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_69_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_70_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 2,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_71_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_72_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_73_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_74_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_75_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_76_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_77_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_78_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_79_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_80_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_81_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "unitType": "unit_d10",
          "newHexKey": "1,-3"
        }
      }
    },
    {
      "id": "entry_82_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "fromHexKey": "3,-4",
          "toHexKey": "1,-3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_83_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "unitType": "unit_d10",
          "newHexKey": "2,-5"
        }
      }
    },
    {
      "id": "entry_84_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "fromHexKey": "4,-6",
          "toHexKey": "2,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_85_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_86_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_87_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 2,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_88_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true,
            "color": "#b09292"
          },
          "round": 2,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_89_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_90_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_91_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_15_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_92_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_93_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_94_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_95_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,3",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_96_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_97_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_98_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-6",
          "unitId": "u_pink_9_6_-7",
          "unitHexKey": "2,-5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_99_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-6",
          "unitId": "u_pink_8_5_-5",
          "unitHexKey": "1,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_100_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,-7",
          "unitId": "u_pink_10_5_-6",
          "unitHexKey": "5,-6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_101_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_102_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 3,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_103_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_104_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_105_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_106_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 3,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_107_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_108_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_109_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_110_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_111_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_112_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_113_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_114_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_115_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_116_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_117_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "unitType": "unit_d10",
          "newHexKey": "0,-3"
        }
      }
    },
    {
      "id": "entry_118_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "fromHexKey": "1,-3",
          "toHexKey": "0,-3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_119_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "unitType": "unit_d10",
          "newHexKey": "1,-5"
        }
      }
    },
    {
      "id": "entry_120_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "fromHexKey": "2,-5",
          "toHexKey": "1,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_121_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_122_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_123_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 3,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_124_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 3,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_125_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ты — вожак гладких. Говори мало. У меня мало терпения и много мёртвых.",
        "characterName": "Ргарх",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m7_rgarh.png"
      }
    },
    {
      "id": "e_126_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Скажу мало. Вам заплатили землёй. Вот купчая Дома Весов на ту же землю — италийцам, годом раньше. Вот — их же контора закладывает её под фактории, годом позже. Одна земля. Три продажи. Считать умеешь?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_stern.png"
      }
    },
    {
      "id": "e_127_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Девять зим назад я продал первый топор, потому что горели наши пастбища. Настоящие. Зверь не предаёт, гладкий. Запомни это, когда будешь рассказывать внукам. Зверь уходит, когда охота лжива. Мы уходим. Не к тебе. ОТ них. Это разное.",
        "characterName": "Ргарх",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m7_rgarh.png"
      }
    },
    {
      "id": "e_128_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Куда вы пойдёте?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_stern.png"
      }
    },
    {
      "id": "e_129_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Домой. Считать. Весовщикам передай: у стаи долгая память и короткие счёты. Пусть выбирают, что им нравится меньше.",
        "characterName": "Ргарх",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m7_rgarh_leave.png"
      }
    },
    {
      "id": "entry_130_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_131_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_132_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_15_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_133_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_134_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_135_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_136_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,3",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_137_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_138_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_139_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-6",
          "unitId": "u_pink_10_5_-6",
          "unitHexKey": "5,-6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_140_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-6",
          "unitId": "u_pink_10_5_-6",
          "unitHexKey": "5,-6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_141_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_142_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 4,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_143_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_144_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_145_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_146_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 4,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_147_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_148_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_149_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_150_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_151_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_152_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_153_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_154_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_155_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_156_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_157_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "unitType": "unit_d10",
          "newHexKey": "2,-4"
        }
      }
    },
    {
      "id": "entry_158_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "fromHexKey": "0,-3",
          "toHexKey": "2,-4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_159_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "unitType": "unit_d10",
          "newHexKey": "3,-6"
        }
      }
    },
    {
      "id": "entry_160_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "fromHexKey": "1,-5",
          "toHexKey": "3,-6",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_161_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_162_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_163_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 4,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_164_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 4,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_165_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Легату Аврелию. Инцидент с подрядчиками Родоп — внутренняя погрешность Дома; виновные исчислены. Не обольщайтесь арифметикой одного дня, легат. Позиции Дома в Италии обеспечены… достаточно. — Вессано иль Морро, синдик».",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m7_vessano_dry.png"
      }
    },
    {
      "id": "e_166_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Исчислены»… Квинт бы сказал: заволновался весовщик. Письмо без цифр — считай, крик.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_stern.png"
      }
    },
    {
      "id": "e_167_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Наёмники подвели — какая безвкусица. Забудь их, Луций: нас двоих это недостойно. Жду на мосту? Шучу. Мосты — для тех, кому нечем платить лодочнику. — С.»",
        "characterName": "Сулла",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m7_sulla_charm.png"
      }
    },
    {
      "id": "e_168_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "И третье, легат. От вахты, на дощечке, как у них водится: «Просьбу о войске вахта не читала, потому что вахта не воюет за людей». А на обороте — метка тракта и три ступени. Не читала, значит… но дорогу нарисовала.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_atilius_calm.png"
      }
    },
    {
      "id": "e_169_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат, руины на гребне — не руины. ХОД. Сухой, тёплый, подпёрт как форум. И вот, у входа, — прибито. Дощечка. «Уходя на юг, вахта не проверила засовы. Стыд ей. Р.»",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_atilius_calm.png"
      }
    },
    {
      "id": "e_170_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Стыд ей»… Тан, тан. Вы не воюете за людей — вы просто забываете двери. Колонну — в ход. Тихо. И, Секст… у стен там зарубки будут. Не считай их.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_quiet.png"
      }
    },
    {
      "id": "e_171_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Почему, легат?",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_atilius_calm.png"
      }
    },
    {
      "id": "e_172_replica",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Потому что это не письмена. Это бухгалтерия. А чужие книги читать — примета дурная: вдруг найдёшь там себя.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_quiet.png"
      }
    },
    {
      "id": "e_173_objective",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h7_forgotten_door",
        "type": "unit_reaches_hex",
        "params": {
          "hexKey": "-5,2"
        },
        "text": "Проведи отряд «забытой дверью» (за рекой обоза нет — дальше выхода отряд тает)",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "entry_174_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_175_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_176_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_15_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_177_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_178_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_179_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_180_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,3",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_181_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_182_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_183_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-6",
          "unitId": "u_pink_9_6_-7",
          "unitHexKey": "3,-6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_184_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-6",
          "unitId": "u_pink_8_5_-5",
          "unitHexKey": "2,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_185_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,-7",
          "unitId": "u_pink_10_5_-6",
          "unitHexKey": "5,-6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_186_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_187_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 5,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_188_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_189_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_190_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_191_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 5,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_192_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_193_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_194_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_195_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_196_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_197_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_198_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_199_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_200_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_201_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_202_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "unitType": "unit_d10",
          "newHexKey": "4,-5"
        }
      }
    },
    {
      "id": "entry_203_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_8_5_-5",
          "fromHexKey": "2,-4",
          "toHexKey": "4,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_204_MOVE_UNIT",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "unitType": "unit_d10",
          "newHexKey": "5,-7"
        }
      }
    },
    {
      "id": "entry_205_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_pink_9_6_-7",
          "fromHexKey": "3,-6",
          "toHexKey": "5,-7",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_206_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_207_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_208_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 5,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_209_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 5,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_210_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат. Держи. Это твоего отца. Написано перед Аравсионом, мне отдал — «если что, передай». Я… не передал. Шесть лет вожу.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_barba_letter.png"
      }
    },
    {
      "id": "e_211_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Шесть лет?! Квинт. ПОЧЕМУ?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_shock.png"
      }
    },
    {
      "id": "e_212_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Потому что я его читал. И потому что тебе, тогдашнему, оно бы сломало хребет. Ты шёл на его спине, мальчик, — на мраморной, на памятниковой. А в письме он… живой. Живые для опоры не годятся. Теперь — годишься сам. Прочтёшь после моста. Обещай: после.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_barba_letter.png"
      }
    },
    {
      "id": "e_213_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Обещаю. Квинт, почему «после моста»? Квинт!",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_shock.png"
      }
    },
    {
      "id": "e_214_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Потому что перед боем читают приказы, а не письма. И вот ещё что, мальчик, раз пошла такая почта. Из нас двоих солдатом был я. Императором будешь ты. Не перепутай, кто из нас кем гордится… Всё, легат, работаем. Мост сам себя не возьмёт.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_barba_letter.png"
      }
    },
    {
      "id": "e_215_despawn",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "despawn",
      "playerColor": "pink"
    },
    {
      "id": "entry_216_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_217_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_218_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_15_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_219_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_220_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_221_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_222_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,3",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_223_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_224_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_225_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_226_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 6,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_227_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_228_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_229_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_230_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 6,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_231_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_232_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_233_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_15_2_3",
          "unitType": "unit_d10",
          "newHexKey": "1,3"
        }
      }
    },
    {
      "id": "entry_234_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_15_2_3",
          "fromHexKey": "2,3",
          "toHexKey": "1,3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_235_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_236_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_237_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_238_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_239_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_240_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_241_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_242_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_243_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 6,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_244_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true,
            "color": "#b09292"
          },
          "round": 6,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "e_245_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Контрудар! Когорты бьют в мост — наших отсекают от переправы! Кто на том берегу — не удержится, легат!",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_dozorny.png"
      }
    },
    {
      "id": "e_246_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Резерв — на мост! Я сам поведу—",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_command.png"
      }
    },
    {
      "id": "e_247_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "НЕТ. Ты — армия. Армия не ходит в заслоны. А я — хожу. Я в этом лучший из живых, спроси кого хочешь… Я один раз уже ушёл живым с моста, мальчик. С Родана. Тридцать лет служу, а донашиваю — с Родана. Второй раз — не пойдёт. Дай старику закрыть счёт по-людски.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_barba_bridge.png"
      }
    },
    {
      "id": "e_248_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Квинт. Это приказ: остаться.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_shock.png"
      }
    },
    {
      "id": "e_249_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Не слышу, легат. Ущелье. Эхо. ЗАСЛОН — ЗА МНОЙ! Работаем, дети, работаем — мост узкий, смерть толстая, все не поместимся!",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_barba_bridge.png"
      }
    },
    {
      "id": "e_250_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "(после боя; подходит, неся гладий; протягивает Луцию — без слов; жест вместо реплики)",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_atilius_grief.png"
      }
    },
    {
      "id": "e_251_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Господин. Люди спрашивают, кому теперь нести кашу старика. Им нужно слово. У меня его нет.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m7_ilva_grief.png"
      }
    },
    {
      "id": "e_252_replica",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Скажи им… «Каша стынет». Он бы так сказал. Всё, Ильва. Иди. Слово у них есть.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_grief.png"
      }
    },
    {
      "id": "e_253_objective",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h7_take_post",
        "type": "capture_city",
        "params": {
          "centralHexKey": "0,3"
        },
        "text": "Займи пост заслона за рекой — его фермы прокормят штурм",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "entry_254_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_255_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_256_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_257_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_15_2_3",
          "unitHexKey": "1,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_258_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_259_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_260_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,3",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_261_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "barba_century",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_262_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_263_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_264_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 7,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_265_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_266_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_267_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_268_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 7,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_269_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_270_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_271_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_15_2_3",
          "unitType": "unit_d10",
          "newHexKey": "0,3"
        }
      }
    },
    {
      "id": "entry_272_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_15_2_3",
          "fromHexKey": "1,3",
          "toHexKey": "0,3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_273_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_274_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "combat",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_275_CALCULATE_MELEE_COMBAT_DAMAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "combat",
        "playerColor": "violet"
      },
      "action": {
        "type": "CALCULATE_MELEE_COMBAT_DAMAGE",
        "payload": {
          "meleeCombatInput": {
            "combatUnits": [
              {
                "id": "u_violet_15_2_3",
                "hexKey": "0,3",
                "ownerId": "player_id_violet",
                "type": "unit_d10",
                "size": 10,
                "maxSize": 10,
                "additionalSupply": false,
                "hasShotThisWarPhase": false,
                "hasFoughtThisWarPhase": false,
                "hasUsedAbilityThisWarPhase": false,
                "diceRoll1": 1,
                "diceRoll2": 1
              },
              {
                "id": "barba_century",
                "hexKey": "0,2",
                "ownerId": "player_id_sky_blue",
                "type": "unit_d8",
                "size": 8,
                "maxSize": 8,
                "additionalSupply": true,
                "hasShotThisWarPhase": false,
                "hasFoughtThisWarPhase": false,
                "hasUsedAbilityThisWarPhase": false,
                "diceRoll1": 1,
                "diceRoll2": 1
              }
            ],
            "unitToEnemiesMapping": {
              "barba_century": [
                {
                  "id": "u_violet_15_2_3",
                  "hexKey": "0,3",
                  "ownerId": "player_id_violet",
                  "type": "unit_d10",
                  "size": 10,
                  "maxSize": 10,
                  "additionalSupply": false,
                  "hasShotThisWarPhase": false,
                  "hasFoughtThisWarPhase": false,
                  "hasUsedAbilityThisWarPhase": false
                }
              ],
              "u_violet_15_2_3": [
                {
                  "id": "barba_century",
                  "hexKey": "0,2",
                  "ownerId": "player_id_sky_blue",
                  "type": "unit_d8",
                  "size": 8,
                  "maxSize": 8,
                  "additionalSupply": true,
                  "hasShotThisWarPhase": false,
                  "hasFoughtThisWarPhase": false,
                  "hasUsedAbilityThisWarPhase": false
                }
              ]
            }
          }
        }
      }
    },
    {
      "id": "entry_276_APPLY_MELEE_DAMAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "combat",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MELEE_DAMAGE",
        "payload": {
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "combat"
        }
      }
    },
    {
      "id": "entry_277_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "combat",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "combat"
        }
      }
    },
    {
      "id": "entry_278_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_279_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_280_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_281_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_282_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 7,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_283_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 7,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "e_284_despawn",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "despawn",
      "playerColor": "sky_blue"
    },
    {
      "id": "entry_285_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_286_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_287_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_288_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_289_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_290_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_291_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_292_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_293_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 8,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_294_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_295_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_296_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_297_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 8,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_298_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_299_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_300_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_301_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_302_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_303_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_304_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_305_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_306_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 8,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_307_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 8,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_308_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_309_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_310_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_311_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_312_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_313_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_314_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_315_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_316_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 9,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_317_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_318_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_319_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_320_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 9,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_321_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_322_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_323_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_324_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_325_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_326_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_327_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_328_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_329_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 9,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_330_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 9,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "e_331_replica",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Луций. Если ты читаешь это — я не вернулся с Родана. Порви предыдущие письма. Все. Я писал их не тебе — я писал их себе, тому Риму из мрамора, в который удобно верить, когда боишься… Я боюсь, сын. Здесь, у Аравсиона, двести тысяч чужого горя стоят напротив нас, и я весь день думаю не о Риме — о том, что ни разу не видел, как ты смеёшься. Я знаю о тебе донесения: здоров, успевает в риторике, послушен. Донесения, Луций. О собственном сыне… Не будь мной. Я всю жизнь был Римом — и не был отцом; из этих двух должностей я выбрал не ту. Если завтра переживу — приеду и начну заново, честное слово солдата. А если нет — то вот тебе единственный приказ, который я имею право отдать: живи так, чтобы твоим детям не понадобились твои письма. Пусть они просто помнят твой голос. — Марк. Просто Марк.»",
        "characterName": "Из писем отца",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_marc_last.png"
      }
    },
    {
      "id": "e_332_replica",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…«Просто Марк»… Хорошо, отец. Порву. Все, кроме этого… Идём домой, армия. Осталось восемьдесят миль и один город. Наш.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m7_lucius_grief.png"
      }
    },
    {
      "id": "entry_333_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_334_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_335_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_336_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_337_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_338_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_339_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_340_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_341_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 10,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_342_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_343_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_344_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_345_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 10,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_346_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_347_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_348_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_349_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_350_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_351_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_352_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_353_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_354_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 10,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_355_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 10,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_356_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,-1",
          "unitId": "u_violet_7_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_357_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,4",
          "unitId": "u_violet_14_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_358_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,4",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_359_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,6",
          "unitId": "u_violet_13_0_6",
          "unitHexKey": "0,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_360_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_12_1_4",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_361_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_362_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_363_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_364_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 11,
          "currentPlayerId": "player_id_pink",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_365_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_366_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_367_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_368_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 11,
          "currentPlayerId": "player_id_pink",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_369_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_370_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_371_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_372_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_373_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_374_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "sky_blue",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "sky_blue"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_sky_blue",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_375_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_376_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_377_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 11,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_378_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "pink",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "pink"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 11,
          "currentPlayerId": "player_id_pink",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    }
  ],
  "objectives": [
    {
      "id": "h7_take_narnia",
      "type": "capture_city",
      "params": {
        "centralHexKey": "1,5"
      },
      "text": "Возьми Нарнию",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h7_night_over_narnia",
      "type": "survive_rounds",
      "params": {
        "rounds": 11
      },
      "text": "Ночь над Нарнией",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h7_hold_bridge",
      "type": "survive_rounds",
      "params": {
        "rounds": 3
      },
      "text": "Продержись 3 раунда: стая бьёт по флангам",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h7_burn_arsenal",
      "type": "destroy_building",
      "params": {
        "hexKey": "1,0"
      },
      "text": "Сожги склад-арсенал Дома Весов у моста (4 попадания катапульт: сперва арсенал, потом форт под ним)",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h7_army_lost",
      "type": "lose_all_units",
      "params": {},
      "text": "Армия не должна погибнуть",
      "isMain": false,
      "isFailure": true
    },
    {
      "id": "h7_forgotten_door",
      "type": "unit_reaches_hex",
      "params": {
        "hexKey": "-5,2"
      },
      "text": "Проведи отряд «забытой дверью» (за рекой обоза нет — дальше выхода отряд тает)",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h7_take_post",
      "type": "capture_city",
      "params": {
        "centralHexKey": "0,3"
      },
      "text": "Займи пост заслона за рекой — его фермы прокормят штурм",
      "isMain": false,
      "isFailure": false
    }
  ]
};

export default mission;
